import { render, staticRenderFns } from "./SeoPageAuthorityContent.vue?vue&type=template&id=80550d82"
import script from "./SeoPageAuthorityContent.vue?vue&type=script&lang=js"
export * from "./SeoPageAuthorityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports